import { selectIsLoading, selectIsLoggedIn } from 'containers/Login/loginSlice'
import { getMessages, getNotifications } from 'containers/Chats/chatSlice'
import { useReduxDispatch, useReduxSelector } from 'store'
import React, { useEffect } from 'react'

interface NotificationProviderProps {
  children: JSX.Element
}

const NotificationProvider: React.FC<NotificationProviderProps> = ({ children }) => {
  const loggedIn = useReduxSelector(selectIsLoggedIn)
  const isLoading = useReduxSelector(selectIsLoading)
  const dispatch = useReduxDispatch()

  useEffect(() => {
    if (isLoading) return
    dispatch(getMessages())
    dispatch(getNotifications())
  }, [dispatch, isLoading, loggedIn])

  return children
}

export default NotificationProvider